<script setup>
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useDetectDevice } from '@/composables/device'

import NavigateBack from '@/components/shared/NavigateBack.vue'
import PdfPreviewPanel from '@/components/shared/PdfPreviewPanel.vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
  source: {
    type: [Object, String],
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  printable: {
    type: Boolean,
    default: false,
  },
  printing: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['cancel', 'print'])

const i18n = getI18n()
const { isMobile } = useDetectDevice()

const splitterModel = ref(30)
</script>
<template>
  <q-card class="dialog-card-flex" :class="{ 'print-dialog-card dialog-lg': !isMobile }">
    <navigate-back :text="title" @cancel="emit('cancel')" />
    <q-card-section class="q-pa-none col print-dialog-body" :class="{ scroll: isMobile }">
      <q-splitter
        v-if="!isMobile"
        v-model="splitterModel"
        :limits="[25, 60]"
        style="height: 100%;"
      >
        <template #before>
          <div class="print-dialog-options scroll">
            <slot name="options" />
          </div>
        </template>
        <template #after>
          <pdf-preview-panel :source="source" :loading="loading" />
        </template>
      </q-splitter>
      <slot v-else name="options" />
    </q-card-section>
    <q-separator />
    <q-card-actions align="center">
      <q-btn
        class="large-btn"
        color="secondary"
        :icon="isMobile ? 'mdi-share-variant' : 'mdi-printer'"
        :label="isMobile ? i18n.t('common.share') : i18n.t('common.print')"
        :loading="printing"
        :disable="!printable"
        @click="emit('print')"
      />
      <slot name="actions" />
    </q-card-actions>
  </q-card>
</template>
<style scoped>
.print-dialog-body {
  min-height: 0;
}

.print-dialog-options {
  height: 100%;
}
</style>
